// store/fpSuspendMiddleware.ts
import type { Middleware } from "@reduxjs/toolkit";
import { isPending, isFulfilled, isRejected } from "@reduxjs/toolkit";
import { fpSuspendGuard } from "../utils/flowplayerSuspend";

type ThunkActionWithMeta = {
  type: string;
  meta?: { requestId?: string; arg?: { fpSuspend?: boolean } };
};

function isAsyncThunkAction(a: unknown): a is ThunkActionWithMeta {
  const x = a as ThunkActionWithMeta | undefined;
  return !!x && typeof x.type === "string" && !!x.meta?.requestId;
}

const shouldSkip = (a: ThunkActionWithMeta) => a.meta?.arg?.fpSuspend === false;

export const fpSuspendMiddleware: Middleware = () => (next) => (action) => {
  try {
    if (!isAsyncThunkAction(action) || shouldSkip(action)) {
      return next(action);
    }
    if (isPending(action as any)) {
      fpSuspendGuard.begin();
    } else if (isFulfilled(action as any) || isRejected(action as any)) {
      fpSuspendGuard.end();
    }
  } catch (e) {
    // 어떤 에러도 디스패치를 막지 않도록
    console.debug("[fp] middleware error (ignored)", e);
  }
  return next(action);
};
